export const numericIdHelper = (id: string | undefined | null) =>
    id && /\d/.test(id) ? Number(id) : null;
